(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[826],{

/***/ 43689:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visitor/purchase",
      function () {
        return __webpack_require__(13879);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 13879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(10797);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25838);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71318);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62010);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85957);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54013);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);



















var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var navDetail = param.navDetail;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), active = ref[0], setActive = ref[1];
    var setIsBecome = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_stores__WEBPACK_IMPORTED_MODULE_4__/* .IndexContext */ .Z).setIsBecome;
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var checkbox = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_10__/* .useTranslations */ .T_)();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), field = ref2[0], setField = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), cates = ref3[0], setCates = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), selectCates = ref4[0], setSelectCates = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), selectChildCates = ref5[0], setSelectChildCates = ref5[1];
    var btnClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _values = formRef.current.getFormState().values, application_area_ids = _values.application_area_ids, params = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_values, [
            "application_area_ids"
        ]);
        formRef.current.validate().then(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
            var ref, data, msg;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request.post("/addPurchase", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, params), {
                                application_area_ids: application_area_ids.join(","),
                                category_ids: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(selectCates).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(selectChildCates)).join(",")
                            }))
                        ];
                    case 1:
                        ref = _state.sent(), data = ref.data, msg = ref.msg;
                        if (data.code == 200) {
                            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Toast.success */ .FN.success({
                                content: t("purchase.success")
                            });
                            formRef.current.reset();
                            return [
                                2
                            ];
                        } else {
                            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Toast.error */ .FN.error({
                                content: data.msg
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        })).catch(function(err) {
            _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Toast.error */ .FN.error({
                content: t("common.tips.all"),
                duration: 3
            });
        });
    }, [
        selectCates,
        selectChildCates
    ]);
    var transOption = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        if (!arr.length) return [];
        return arr === null || arr === void 0 ? void 0 : arr.map(function(item) {
            return {
                // ...item,
                children: transOption(item.childlist),
                key: item.id,
                value: item.id,
                label: (item === null || item === void 0 ? void 0 : item["name_".concat(router.locale)]) || item.name
            };
        }).filter(function(item) {
            return !!item.label;
        });
    }, [
        router.locale
    ]);
    var filterUnique = function(sourceArr, filterArr) {
        var filterSet = new Set(filterArr);
        return sourceArr.filter(function(item) {
            return !filterSet.has(item);
        });
    };
    var findNode = function(source, filter) {
        var ref, ref1;
        var filterSet = new Set(filter);
        //@ts-ignore
        var id = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(new Set(source)).filter(function(item) {
            return !filterSet.has(item);
        })[0];
        return (ref = cates.find(function(item) {
            return item.value == id;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
            return item.value;
        });
    };
    var getFiled = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(filed) {
        return formRef.current.getValue(filed);
    }, [
        formRef.current
    ]);
    var getData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
        var ref, _data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.get("/getApplicationAreaList")
                    ];
                case 1:
                    ref = _state.sent(), _data = ref.data;
                    setField(transOption(_data === null || _data === void 0 ? void 0 : _data.data));
                    setCates(transOption(navDetail === null || navDetail === void 0 ? void 0 : navDetail.list));
                    return [
                        2
                    ];
            }
        });
    }), [
        router.locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getData();
    }, [
        getData
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().container) || ""),
        children: [
            (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_3__/* .getHead */ .c)(navDetail),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-bdf256b032c10329",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().top) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().left) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "jsx-bdf256b032c10329",
                                        children: t("purchase.title1")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-bdf256b032c10329",
                                        children: t("purchase.title2")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                        className: "jsx-bdf256b032c10329",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                className: "jsx-bdf256b032c10329",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.advantage1")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.advantage1-2")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                className: "jsx-bdf256b032c10329",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.advantage2")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.advantage2-2")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                className: "jsx-bdf256b032c10329",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.advantage3")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.advantage3-3")
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().right) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().shape) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/image/purchase-shape.png",
                                                alt: "",
                                                className: "jsx-bdf256b032c10329"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-bdf256b032c10329" + " " + (classnames__WEBPACK_IMPORTED_MODULE_6___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, (_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().enSpan), router.locale === "en")) || ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().tag) || ""),
                                                        children: t("purchase.consultant")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: [
                                                            router.locale === "cn" && "粉小姐",
                                                            " Miss.Powder"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.contact1")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/image/engineer.png",
                                        alt: "",
                                        className: "jsx-bdf256b032c10329"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().form) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Form */ .l0, {
                                getFormApi: function(formApi) {
                                    return formRef.current = formApi;
                                },
                                labelPosition: "top",
                                children: function(param) {
                                    var formState = param.formState, values = param.values, formApi = param.formApi;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().box) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().tips) || ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title) || ""),
                                                        children: t("purchase.tipTitle")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                className: "jsx-bdf256b032c10329",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "jsx-bdf256b032c10329",
                                                                        children: "1"
                                                                    }),
                                                                    t("purchase.tip1")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                className: "jsx-bdf256b032c10329",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "jsx-bdf256b032c10329",
                                                                        children: "2"
                                                                    }),
                                                                    t("purchase.tip2")
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                                className: "jsx-bdf256b032c10329",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "jsx-bdf256b032c10329",
                                                                        children: "3"
                                                                    }),
                                                                    t("purchase.tip3")
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().type) || ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        style: {
                                                            marginBottom: "20px"
                                                        },
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.type")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .CheckboxGroup */ .cO, {
                                                        className: "type",
                                                        onChange: function(checkedValues) {
                                                            if (checkedValues.length < cates.length) {
                                                                setSelectChildCates(filterUnique(selectChildCates, findNode(selectCates, checkedValues)));
                                                            }
                                                            setSelectCates(checkedValues);
                                                        },
                                                        children: cates === null || cates === void 0 ? void 0 : cates.map(function(item) {
                                                            var ref;
                                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "jsx-bdf256b032c10329",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Checkbox */ .XZ, {
                                                                        value: item.value,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            style: {
                                                                                marginBottom: "6px"
                                                                            },
                                                                            className: "jsx-bdf256b032c10329",
                                                                            children: item.label
                                                                        })
                                                                    }),
                                                                    !!((ref = item.children) === null || ref === void 0 ? void 0 : ref.length) && selectCates.includes(item.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .CheckboxGroup */ .cO, {
                                                                        style: {
                                                                            marginLeft: "20px"
                                                                        },
                                                                        options: item.children,
                                                                        onChange: function(checkedValues) {
                                                                            setSelectChildCates(checkedValues);
                                                                        }
                                                                    })
                                                                ]
                                                            }, item.id);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().filed) || ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.filed")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Form.CheckboxGroup */ .l0.CheckboxGroup, {
                                                        className: "filed",
                                                        field: "application_area_ids",
                                                        options: field,
                                                        noLabel: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().words) || ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().required) || ""),
                                                        children: t("purchase.content")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        style: {
                                                            fontSize: "14px"
                                                        },
                                                        className: "jsx-bdf256b032c10329",
                                                        children: t("purchase.tip4")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Form.TextArea */ .l0.TextArea, {
                                                        field: "content",
                                                        placeholder: t("purchase.contentPlaceholder"),
                                                        noLabel: true,
                                                        trigger: "blur",
                                                        style: {
                                                            height: "200px"
                                                        },
                                                        rules: [
                                                            {
                                                                required: true,
                                                                message: t("become.tips.required")
                                                            }, 
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().grid) || ""),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Form.Input */ .l0.Input, {
                                                                field: "truename",
                                                                placeholder: t("purchase.namePlaceholder"),
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().required) || ""),
                                                                    children: t("purchase.name")
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: t("become.tips.required")
                                                                    }, 
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Form.Input */ .l0.Input, {
                                                                field: "mobile",
                                                                placeholder: t("purchase.mobilePlaceholder"),
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().required) || ""),
                                                                    children: t("purchase.mobile")
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: t("become.tips.required")
                                                                    }, 
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Form.Input */ .l0.Input, {
                                                                field: "email",
                                                                placeholder: t("purchase.emailPlaceholder"),
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().required) || ""),
                                                                    children: t("purchase.email")
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: t("become.tips.required")
                                                                    }, 
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Form.Input */ .l0.Input, {
                                                                field: "position",
                                                                placeholder: t("purchase.positionPlaceholder"),
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().required) || ""),
                                                                    children: t("purchase.position")
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: t("become.tips.required")
                                                                    }, 
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_5__/* .Form.Input */ .l0.Input, {
                                                                field: "company",
                                                                placeholder: t("common.placeholder.company"),
                                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().required) || ""),
                                                                    children: t("become.companyName")
                                                                }),
                                                                trigger: "blur",
                                                                rules: [
                                                                    {
                                                                        required: true,
                                                                        message: t("become.tips.required")
                                                                    }, 
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().footer) || ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().btns) || ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: (0,lodash__WEBPACK_IMPORTED_MODULE_8__.debounce)(function() {
                                            return btnClick();
                                        }, 500),
                                        className: "jsx-bdf256b032c10329" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_17___default().subBtn) || ""),
                                        children: t("become.submit")
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "bdf256b032c10329",
                children: ".filed{display:grid;grid-template-columns:repeat(auto-fill,minmax(285px,1fr))}.type{display:grid;grid-template-columns:repeat(auto-fill,minmax(468px,1fr));gap:20px 0}.semi-tree-select-selection .semi-tag{height:34px!important}.semi-table-row,.semi-table-row-cell{height:80px;border-bottom:none}.semi-page-item{font-size:16px;color:#333;margin:0 5px}.semi-page-item:hover{background-color:#eaf3ee}.semi-page-item-active{color:white!important;background:#6354a2!important;border:none!important}.semi-modal-header{border-bottom:1px solid#ddd;padding-bottom:30px}.semi-modal-title{color:#094020;font-size:24px!important;font-weight:500!important}.semi-dropdown-item{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}.semi-form-field-label-text::after{display:none}.semi-input-textarea{height:100%}.semi-radioGroup{min-height:50px;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}.semi-tree-option{padding:8px 12px!important}.semi-form-field-label{font-weight:500;padding-right:20px;font-size:16px;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-webkit-align-items:flex-start;-moz-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:right;-webkit-justify-content:right;-moz-box-pack:right;-ms-flex-pack:right;justify-content:right;margin-top:8px}.semi-form-slot .semi-form-field-label{margin-top:0px}.custom .semi-form-field-label-text{margin-top:10px}.semi-input-wrapper,.semi-select,.semi-tree-select{width:100%;background:white;height:56px;line-height:56px;border:1px solid#ddd;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.semi-input-textarea-wrapper{width:100%;background:white!important;border:1px solid#ddd;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;padding-top:10px}.semi-input-wrapper:hover,.semi-select:hover,.semi-tree-select:hover{border:1px solid#6354a2}.semi-form-field{padding:14px 0}.semi-radioGroup{padding:0!important}.semi-radio-inner,.semi-radio-inner-display,.semi-checkbox-inner,.semi-checkbox-inner-display{width:18px!important;height:18px!important;background:white}.semi-checkbox-checked .semi-checkbox-inner-display{border-style:#6354a2!important;background:#6354a2!important;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none}.semi-radio-checked .semi-radio-inner-display{border:2px solid#6354a2!important;background:white!important}.semi-radio-inner-display .semi-icon{color:#6354a2;-webkit-transform:scale(1.2)translate(-2px,-2px);-moz-transform:scale(1.2)translate(-2px,-2px);-ms-transform:scale(1.2)translate(-2px,-2px);-o-transform:scale(1.2)translate(-2px,-2px);transform:scale(1.2)translate(-2px,-2px)}.semi-radio:hover .semi-radio-inner-display{border:2px solid#6354a2!important}.is-check .semi-checkbox-inner-display,.is-check .semi-checkbox-inner-display:hover{background:white!important}.is-check .semi-checkbox-inner-checked span{background:#6354a2!important;overflow:hidden}.semi-icon-default{font-size:18px!important}.semi-input-wrapper-disabled,.semi-select-disabled{background-color:#f3f5f9}.slot .semi-form-field-label{display:none!important}.semi-form-slot .semi-form-field{padding:0!important}.semi-input-number{width:100%}.semi-table-container{margin-bottom:20px}.semi-table-cell-fixed-right-first{border-left:none!important}.semi-checkbox-indeterminate .semi-checkbox-inner-display{background:#6354a2;-webkit-box-shadow:0 0 0 1px#6354a2;-moz-box-shadow:0 0 0 1px#6354a2;box-shadow:0 0 0 1px#6354a2}.semi-table-row-head{color:#999!important;white-space:nowrap}@media screen and (max-width:887px){.semi-form-field-label{-webkit-box-pack:left!important;-webkit-justify-content:left!important;-moz-box-pack:left!important;-ms-flex-pack:left!important;justify-content:left!important;padding:0 0 20px!important;margin-top:0}.semi-form-field{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:0!important}.type{grid-template-columns:1fr!important}.semi-form-field-label-text{white-space:nowrap}}"
            })
        ]
    });
};


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/getHomeMenuDetail", {
                            params: {
                                path: context === null || context === void 0 ? void 0 : (ref = context.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")[0]
                            },
                            headers: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            props: {
                                navDetail: data.data || null,
                                menuDetail: data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title,
                    " "
                ]
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 71318:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"purchase_m-1480__UPP6O","container":"purchase_container__3RnkE","top":"purchase_top__K8lPf","left":"purchase_left__GeazW","right":"purchase_right__2hRCg","enSpan":"purchase_enSpan__PCJ6B","tag":"purchase_tag__aqpyI","form":"purchase_form__rrvRa","tips":"purchase_tips__BNd4H","title":"purchase_title__zzvqj","box":"purchase_box__9veWi","required":"purchase_required__ZSV0t","grid":"purchase_grid__mnFmp","type":"purchase_type__8TQrm","filed":"purchase_filed__ZBduK","words":"purchase_words__gAsYn","footer":"purchase_footer__gtiFT","btns":"purchase_btns__56ORl","subBtn":"purchase_subBtn__guy98","allow":"purchase_allow__ne1Rc"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,774,888,179], function() { return __webpack_exec__(43689); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);